import { createFileRoute } from "@tanstack/react-router";
import VerComoPaciente from "@/pages/admin/VerComoPaciente";
import { pageHead } from "@/lib/seo";

// "Ver como a paciente": fora da página do paciente (sem as abas), com o app dela dentro de um celular.
export const Route = createFileRoute("/admin/pacientes/$id_/app")({
  head: () => pageHead({ title: "Ver como a paciente | Painel", path: "/admin/pacientes", noindex: true }),
  component: VerComoPaciente,
});
